/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
import { ImpressionProvider } from '@thd-olt-component-react/impression';

const { bool, number: numberType, string: stringType } = proptypes;

/*
 * This is a Higher Order Component (HOC) that returns the component wrapped in an ImpressionProvider.
 */
const withImpressions = (Component) => {
  const Sub = ({
    componentClass = '',
    componentId,
    slotContentId,
    componentPosition = 1,
    lazyLoad = false,
    enableB2CRadius = false,
    mediaCollectionIndex,
    theme,
    fetchpriority
  }) => {
    const impressionId = componentId || slotContentId;

    return (
      <ImpressionProvider
        data={{
          id: impressionId,
          name: 'InternalMarketingBanner',
          component: 'InternalMarketingBanner',
          type: 'content',
        }}
      >
        <Component
          componentClass={componentClass}
          componentId={componentId}
          slotContentId={slotContentId}
          componentPosition={componentPosition}
          lazyLoad={lazyLoad}
          enableB2CRadius={enableB2CRadius}
          mediaCollectionIndex={mediaCollectionIndex}
          theme={theme}
          fetchpriority={fetchpriority}
        />
      </ImpressionProvider>
    );
  };

  Sub.propTypes = {
    componentClass: stringType,
    componentId: stringType,
    slotContentId: stringType,
    componentPosition: numberType,
    lazyLoad: bool,
    enableB2CRadius: bool,
    mediaCollectionIndex: numberType,
    theme: stringType,
    fetchpriority: stringType
  };

  return Sub;
};

export { withImpressions };